import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { Fiat } from "@models";
import { UserService } from "@main-services/user.service";
import { FiatService } from "@main-services/currency";
import { StakingModalFlowModel } from "@modules/staking/domain/entities/staking-modal-flow.model";
import { StakedAssetFacade } from "@modules/staking/domain/+state/staked-asset.facade";

@Component({
	selector: "app-staking-widget-reward",
	templateUrl: "staking-widget-reward.component.html",
	styleUrls: ["staking-widget-reward.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingWidgetRewardComponent implements OnInit {
	@Output() public openModalFlow: EventEmitter<StakingModalFlowModel> = new EventEmitter<StakingModalFlowModel>();
	@Output() public openRewardsFlow: EventEmitter<string> = new EventEmitter<string>();

	public stakedAsset$: Observable<Stakeable> = this.stakedAssetFacade.getAdpStakeable$();
	public defaultFiat: Fiat | null = null;

	constructor(
		private readonly userService: UserService,
		private readonly fiatService: FiatService,
		private readonly stakedAssetFacade: StakedAssetFacade
	) {}

	public ngOnInit(): void {
		this.defaultFiat = this.fiatService.getItemById(this.userService.user.getFiatId());
	}
}
